<template>
  <component :is="tag">
    {{ content }}
  </component>
</template>

<script>

export default {
  name: 'MsSafeDisplay',

  props: {
    // Thẻ HTML hiển thị
    tag: {
      type: String,
      default: 'div'
    },

    // Nội dung binding
    content: {
      type: String,
      default: ''
    }
  }
}
</script>
